import type { Dictionary } from '@protector/utils/types';
import { create } from 'zustand';

export interface IndicatorValue {
  value: string;
  color: string;
}

export type ActiveSeveritySelection = { type: 'monitoring'; indicatorId: string } | { type: 'trap'; indicatorKey: string };

interface IndicatorValuesStore {
  showIndicatorValues: boolean;
  isRainGaugePanelOpen: boolean;
  indicatorValues: Dictionary<IndicatorValue>;
  activeSeveritySelection?: ActiveSeveritySelection;
  setShowIndicatorValues: (value: boolean) => void;
  setIsRainGaugePanelOpen: (value: boolean) => void;
  setIndicatorValues: (values: Dictionary<IndicatorValue>) => void;
  setActiveSeveritySelection: (selection: ActiveSeveritySelection | undefined) => void;
  reset: () => void;
}

export const useIndicatorValuesStore = create<IndicatorValuesStore>()(set => ({
  showIndicatorValues: true,
  isRainGaugePanelOpen: false,
  indicatorValues: {},
  activeSeveritySelection: undefined,
  setShowIndicatorValues: showIndicatorValues => set({ showIndicatorValues }),
  setIsRainGaugePanelOpen: isRainGaugePanelOpen => set({ isRainGaugePanelOpen }),
  setIndicatorValues: indicatorValues => set({ indicatorValues }),
  setActiveSeveritySelection: activeSeveritySelection => set({ activeSeveritySelection }),
  reset: () => set({ showIndicatorValues: true, indicatorValues: {}, activeSeveritySelection: undefined })
}));
